import React, { SetStateAction, useEffect, useState } from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import { useNavigate } from 'react-router-dom';
import { usePath } from 'shared/hooks';
import { viewerModel } from 'entities/viewer';
import { useNotifications } from 'shared/hooks/use-notifications';
import { ReferenceModal } from 'features/references/referenceModal';
import { useHrCloseMutation } from 'app/services/edpApiV1/references';
import { getErrorData } from 'shared/helpers/utils';
import { uiModel } from 'entities/ui';

import { useAppSelector } from 'app/store';
import {
  useApproveAbsenceMutation,
  useApproveArrayAbsenceMutation,
  useRejectAbsenceMutation,
  useRejectArrayAbsenceMutation,
} from 'app/services/edpApiV1/absence';
import { TUnionTableData } from 'shared/types/types';
import { VacationsModel } from 'entities/vacations-applications';
import { useApproveVacationVAMutation, useLazySingleVacationVAQuery } from 'app/services/edpApiV1/vacationApplication';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { RolesUser } from 'shared/enums';
import { VacationModal } from '../vacationModal';

import style from './index.module.scss';
//TODO:Вынести как общий компонент
export const NavigatesAndAgreement = ({
  id,
  ids,
  tabKey,
  setSelectUser,
  currentPage,
  currentSize,
  setIsBtnGroupVisible,
  isBtnGroupVisible = true,
}: {
  id: string;
  ids?: number[];
  tabKey: string;
  setSelectUser?: React.Dispatch<SetStateAction<TUnionTableData>>;
  currentPage?: number;
  currentSize?: number;
  setIsBtnGroupVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  isBtnGroupVisible?: boolean;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalRef, setOpenModalRef] = useState(false);
  const [label, setLabel] = useState<string>();

  const navigate = useNavigate();
  const pathUser = usePath(2);
  const mainPath = usePath(1);

  const { blockHrActions } = useAppSelector(uiModel.Common.selectors.selectCommon);
  const { role, id: profileId } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { active } = useAppSelector(uiModel.Tabs.selectors.selectTabs);
  const { selectedVacation } = useAppSelector(VacationsModel.SelectedVacation.selectors.getSelectedVacation);
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [closeHrTrigger, setHrClose] = useHrCloseMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
  });
  const { isSuccess: closeSuccess, isError: closeReject, error: errorClose, reset: resetClose } = setHrClose;

  const [triggerApprove, resultApprove] = useApproveVacationVAMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
  });
  const { isSuccess, isError, error: errorApprove, reset } = resultApprove;

  const [absenceApproveTrigger] = useApproveAbsenceMutation({
    fixedCacheKey: 'approveAbsence',
  });
  const [absenceRejectTrigger] = useRejectAbsenceMutation({
    fixedCacheKey: 'rejectAbsence',
  });

  const [absenceArrayApproveTrigger] = useApproveArrayAbsenceMutation({
    fixedCacheKey: 'approveArrayAbsence',
  });

  const [absenceArrayRejectTrigger] = useRejectArrayAbsenceMutation({
    fixedCacheKey: 'rejectArrayAbsence',
  });

  const [vacationSingleTrigger, resultVacationSingle] = useLazySingleVacationVAQuery();
  const { data: dataSingleVacation } = resultVacationSingle;

  const onUserPage = () => {
    if (mainPath === 'vacation' && tabKey !== 'myArchive' && tabKey !== 'otherArchive') {
      navigate(`/vacation/user/${id}`, { state: { page: currentPage, size: currentSize } });
    }
    if (mainPath === 'vacation' && tabKey === 'myArchive') {
      navigate(`/vacation/archive/user/${id}`, { state: { page: currentPage, size: currentSize } });
    }
    if (mainPath === 'vacation' && tabKey === 'otherArchive') {
      navigate(`/vacation/archive/user/subordination/${id}`, { state: { page: currentPage, size: currentSize } });
    }
    if (mainPath === 'consultations' && tabKey !== 'myArchive' && tabKey !== 'otherArchive') {
      navigate(`/consultations/${id}`);
    }
    if (mainPath === 'consultations' && tabKey === 'myArchive') {
      navigate(`/consultations/archive/user/${id}`);
    }
    if (mainPath === 'consultations' && tabKey === 'otherArchive') {
      navigate(`/consultations/archive/user/subordination/${id}`);
    }
    if (mainPath === 'references' && tabKey !== 'myArchive' && tabKey !== 'otherArchive') {
      navigate(`/references/${id}`);
    }
    if (mainPath === 'references' && tabKey === 'myArchive') {
      navigate(`/references/archive/user/${id}`);
    }
    if (mainPath === 'references' && tabKey === 'otherArchive') {
      navigate(`/references/archive/user/subordination/${id}`);
    }
    if (mainPath === 'rvd' && tabKey !== 'myArchive' && tabKey !== 'otherArchive') {
      navigate(`/rvd/${id}`);
    }
    if (mainPath === 'absence' && tabKey !== 'myArchive' && tabKey !== 'otherArchive') {
      navigate(`/absence/user/${id}`);
    }
    if (mainPath === 'absence' && tabKey === 'otherArchive') {
      navigate(`/absence/archive/user/subordination/${id}`);
    }
    if (mainPath === 'absence' && tabKey === 'myArchive') {
      navigate(`/absence/archive/user/${id}`);
    }
  };

  const agreedVacation = () => {
    if (id) {
      triggerApprove({ employeeId: Number(profileId), reqiestId: +id });
      if (setIsBtnGroupVisible) setIsBtnGroupVisible(false);
    }
  };

  const rejectionVacation = () => {
    setOpenModal(true);
  };

  const rejectionReference = () => {
    if (id) {
      setOpenModalRef(true);
      setLabel('rejection');
    }
  };

  const closeReference = () => {
    if (!id) {
      return;
    }
    closeHrTrigger({ requestId: id, allAvailableOrganizations });
    setLabel('close');
    // скрываю кнопки 'Отклонить' 'Подробнее', 'Готова к выдаче'
    if (setSelectUser) setSelectUser([]);
  };

  const messageForAction = (type: string) => {
    switch (selectedVacation?.type) {
      case 'Перенос':
        return `Вы уверены, что хотите ${type} заявление на перенос отпуска?`;
      case 'Отмена':
        return `Вы уверены, что хотите ${type} заявление на отмену отпуска?`;
      default:
        return `Вы уверены, что хотите ${type} заявление на отпуск?`;
    }
  };

  const rejectionAbsence = async () => {
    if (ids) await absenceArrayRejectTrigger({ requestIds: ids });
    else if (id) await absenceRejectTrigger({ requestId: Number(id) });

    // скрываю кнопки 'Отклонить' 'Подробнее', 'Готова к выдаче'
    if (setSelectUser) setSelectUser([]);
  };

  const approveAbsence = async () => {
    if (ids) await absenceArrayApproveTrigger({ requestIds: ids });
    else if (id) await absenceApproveTrigger({ requestId: Number(id) });

    //снимаю выбор с чекбоксов
    if (setSelectUser) setSelectUser([]);
  };

  useEffect(() => {
    if (mainPath === 'vacation') {
      vacationSingleTrigger({ employeeId: Number(profileId), requestId: +id });
    }
  }, [vacationSingleTrigger, id]);

  useNotifications(isSuccess, isError, 'Отправлено на согласование', errorApprove?.message, reset);
  useNotifications(closeSuccess, closeReject, 'Заявление успешно закрыто', errorClose?.message, resetClose);

  return (
    <>
      {pathUser !== 'myArchive' && (
        <>
          <div className={style.btnsGroup}>
            {/* Скрываю кнопку для раздела "Неявки" */}
            {!pathUser && mainPath !== 'absence' && (
              <>
                <Button type="default" onClick={onUserPage}>
                  Подробнее
                </Button>
              </>
            )}

            {mainPath === 'vacation' &&
              tabKey !== 'myArchive' &&
              tabKey !== 'otherArchive' &&
              // selectedVacation?.key !== '0'
              isBtnGroupVisible && (
                <>
                  <Popconfirm
                    placement="topRight"
                    title={messageForAction('отклонить')}
                    onConfirm={rejectionVacation}
                    cancelText="Отмена"
                    okText="Да"
                    disabled={blockHrActions || dataSingleVacation?.request.status.type === 'rejectedByHR'}
                  >
                    <Button
                      type="default"
                      disabled={blockHrActions || dataSingleVacation?.request.status.type === 'rejectedByHR'}
                    >
                      Отклонить
                    </Button>
                  </Popconfirm>

                  <Popconfirm
                    placement="topRight"
                    title={messageForAction('согласовать')}
                    onConfirm={agreedVacation}
                    cancelText="Отмена"
                    okText="Да"
                    disabled={blockHrActions || dataSingleVacation?.request.status.type === 'rejectedByHR'}
                  >
                    <Button
                      type="primary"
                      icon={<CheckOutlined />}
                      disabled={blockHrActions || dataSingleVacation?.request.status.type === 'rejectedByHR'}
                    >
                      Согласовать
                    </Button>
                  </Popconfirm>
                </>
              )}

            {mainPath === 'references' && tabKey !== 'myArchive' && tabKey !== 'otherArchive' && (
              <>
                {role !== RolesUser.Consultant && active !== 'myWaiting' && (
                  <>
                    <Popconfirm
                      placement="topRight"
                      title={'Вы уверены, что хотите отклонить заявку на справку?'}
                      onConfirm={rejectionReference}
                      cancelText="Отмена"
                      okText="Да"
                    >
                      <Button type="default">Отклонить</Button>
                    </Popconfirm>

                    <Popconfirm
                      placement="topRight"
                      title={'Вы уверены что хотите закрыть заявку?'}
                      onConfirm={closeReference}
                      cancelText="Отмена"
                      okText="Да"
                    >
                      <Button type="primary" icon={<CheckOutlined />}>
                        Готова к выдаче
                      </Button>
                    </Popconfirm>
                  </>
                )}
              </>
            )}

            {mainPath === 'absence' && tabKey !== 'myArchive' && tabKey !== 'otherArchive' && (
              <>
                {role !== RolesUser.Consultant && active !== 'myWaiting' && (
                  <>
                    <Popconfirm
                      placement="topRight"
                      title={'Вы уверены, что хотите отклонить заявление о неявке?'}
                      onConfirm={rejectionAbsence}
                      cancelText="Отмена"
                      okText="Да"
                    >
                      <Button type="default">Отклонить</Button>
                    </Popconfirm>

                    <Popconfirm
                      placement="topRight"
                      title={'Вы уверены что хотите согласовать заявление о неявке?'}
                      onConfirm={approveAbsence}
                      cancelText="Отмена"
                      okText="Да"
                    >
                      <Button type="primary" icon={<CheckOutlined />}>
                        Согласовать
                      </Button>
                    </Popconfirm>
                  </>
                )}
              </>
            )}
          </div>
        </>
      )}

      <VacationModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        id={id}
        setSelectUser={setSelectUser}
        setIsBtnGroupVisible={setIsBtnGroupVisible}
      />

      {label && (
        <ReferenceModal
          setSelectUser={setSelectUser}
          openModal={openModalRef}
          setOpenModal={setOpenModalRef}
          id={id}
          label={label}
        />
      )}
    </>
  );
};
